/* eslint-disable no-param-reassign */
import { createTPluginFactory } from '../../plate';
import { KEY_STORE } from '../../pluginKeys';
import { StorePluginOptions } from './types';
import { withStore } from './withStore';

export const createTextEditorStorePlugin = createTPluginFactory<StorePluginOptions>({
  key: KEY_STORE,
  options: {
    createInitialState: () => ({
      editor: null,
      selectedElementPaths: [],
      hoveredElementPath: null,
      isSlashCommandOpen: false,
      slashCommandOptions: [],
    }),
  },
  withOverrides: withStore,
});
